import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { ResponsivePicture, singleCrop } from "../../../Shared/components/Image";
export const ImageBlock = (p)=>/*#__PURE__*/ _jsx("div", {
        className: "image-block__wrapper",
        children: /*#__PURE__*/ _jsx("div", {
            className: "image-block__inner",
            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                lazyload: false,
                defaultImageUrl: p.imageUrlFallback,
                cropsPerMedia: singleCrop(p.imageUrl),
                imgClassName: "image-block__image",
                alt: p.imageAlt
            })
        })
    });
